import source from '../downloaded/char2statsPerks.json' assert { type: 'json' };

export const statsPerksdata = {}

function split(s) {
  if (!s || s === '') {
    return [];
  }
  return s.split(',').map((s) => s.trim());
}

for (const row of source) {
  const { key, name, descr, stat, minStat, require, overwrite, tags, level, perkPower } = row
  statsPerksdata[key] = {
    name,
    descr,
    stat,
    minStat: +minStat,
    requires: split(require),
    overwrites: split(overwrite),
    tags: split(tags),
    level: +level,
    perkPower: +perkPower,
  }
}
